import React, { createContext, useState, useContext, useEffect } from 'react';
import { Platform } from 'react-native';
import Storage from '../utils/Storage';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [direcciones, setDirecciones] = useState([]);
  const [codUsu, setCodUsu] = useState('');
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [mail, setMail] = useState('');
  const [genero, setGenero] = useState('');
  const [fecnac, setFecNac] = useState('');
  const [cel, setCel] = useState('');
  const [tel, setTel] = useState('');
  const [calle, setCalle] = useState('');
  const [nro, setNro] = useState('');
  const [codPostal, setCodPostal] = useState('');
  const [codBarrio, setCodBarrio] = useState('');
  const [piso, setPiso] = useState('');
  const [ciudad, setCiudad] = useState('');

  useEffect(() => {
    loadStoredUser();
  }, []);

  const loadStoredUser = async () => {
    try {
      // Usamos nuestra abstracción de almacenamiento que funciona en todas las plataformas
      const storedCodUsu = await Storage.getItem('codUsu');
      const storedNombre = await Storage.getItem('nombre');
      const storedMail = await Storage.getItem('mail');
      const storedGenero = await Storage.getItem('genero');
      const storedfecnac = await Storage.getItem('fecnac');

      const storedCel = await Storage.getItem('cel');
      const storedTel = await Storage.getItem('tel');

      if (storedCodUsu) setCodUsu(storedCodUsu);
      if (storedNombre) setNombreUsuario(storedNombre);
      if (storedMail) setMail(storedMail);
      if (storedGenero) setGenero(storedGenero);
      if (storedfecnac) setFecNac(storedfecnac);

      if (storedCel) setCel(storedCel);
      if (storedTel) setTel(storedTel);
      
    } catch (error) {
      console.error('Error loading stored user:', error);
    }
  };

  // Convierte YYYY-MM-DD a DD/MM/YYYY si aplica
  const isoToDMY = (val) => {
    if (!val) return '';
    if (val.includes('/')) return val;
    const parts = val.split('-');
    if (parts.length === 3) {
      const [y, m, d] = parts;
      return `${d}/${m}/${y}`;
    }
    return val;
  };

  const updateUser = async (data) => {
    try {
      // Actualizar el estado
      if (data.codUsu) {
        setCodUsu(data.codUsu);
        await Storage.setItem('codUsu', data.codUsu);
      }

      if (data.nombre !== undefined) {
        setNombreUsuario(data.nombre || '');
        await Storage.setItem('nombre', data.nombre || '');
      }

      if (data.mail) {
        setMail(data.mail);
        await Storage.setItem('mail', data.mail);
      }

      if (data.genero) {
        setGenero(data.genero);
        await Storage.setItem('genero', data.genero);
      }

      // Aceptar fecha desde 'fechaNac' o 'fecnac' y normalizar a DD/MM/YYYY
      const incomingFecha = data.fechaNac || data.fecnac;
      if (incomingFecha !== undefined) {
        const normalized = isoToDMY(incomingFecha) || '';
        setFecNac(normalized);
        await Storage.setItem('fecnac', normalized);
      }

      if (data.cel !== undefined) {
        setCel(data.cel || '');
        await Storage.setItem('cel', data.cel || '');
      }

      if (data.tel !== undefined) {
        setTel(data.tel || '');
        await Storage.setItem('tel', data.tel || '');
      }
      
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  const clearUser = async () => {
    try {
      // Eliminar datos del almacenamiento
      await Storage.removeItem('codUsu');
      await Storage.removeItem('nombre');
      await Storage.removeItem('mail');
      await Storage.removeItem('genero');
      await Storage.removeItem('fecnac');
      await Storage.removeItem('cel');
      await Storage.removeItem('tel');

      setCodUsu('');
      setNombreUsuario('');
      setMail('');
      setGenero('');
      setFecNac('');
      setCel('');
      setTel('');

    } catch (error) {
      console.error('Error clearing user data:', error);
    }
  };

  // Función de logout que limpia datos y redirige
  const logout = async () => {
    try {
      // Limpiar datos del usuario
      await clearUser();
      
      // Redireccionar al home según la plataforma
      if (Platform.OS === 'web' && typeof window !== 'undefined') {
        window.location.href = '/';
      }
      // Para React Native móvil, la navegación debe hacerse desde el componente
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <UserContext.Provider
      value={{
        codUsu,
        nombreUsuario,
        mail,
        genero,
        fecnac,
        cel,
        tel,
        calle,
        nro,
        codPostal,
        codBarrio,
        piso,
        ciudad,
        updateUser,
        clearUser,
        logout,
        setCiudad,
        setCodPostal,
        setCodBarrio
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);